import type { RecommendationPlacement, RecommendationPosition } from '@parentpath/supabase-client';
import { useRecommendation } from '../hooks/useRecommendation';
import { RecommendationCard } from './RecommendationCard';
import { getPlacementSetting } from '../placementDefaults';

interface Props {
  placement: RecommendationPlacement;
  /** Only render if the recommendation's configured position matches. If omitted, always renders. */
  position?: RecommendationPosition;
  className?: string;
}

export function RecommendationSlot({ placement, position, className }: Props) {
  const { recommendation, canDismiss, dismiss } = useRecommendation(placement);

  if (!recommendation) return null;

  const setting = getPlacementSetting(recommendation, placement);
  if (position && setting.position !== position) return null;

  return (
    <div className={className}>
      <RecommendationCard
        recommendation={recommendation}
        placement={placement}
        canDismiss={canDismiss}
        onDismiss={dismiss}
        variant={setting.variant}
      />
    </div>
  );
}
